import { useRouter } from "next/router";
import { useState } from "react";
//Dimitri codou aqui kakakaka
import { ArrowRightIcon } from "@chakra-ui/icons";
import {
  Box,
  Button,
  Collapse,
  Flex,
  Link,
  Switch,
  Text,
  useBreakpointValue,
  useToast,
  Image
} from "@chakra-ui/react";

import { FormPF, FormPJ } from "@/components/Form";
import { SEO } from "@/components/SEO";
import { ContentBox, Layout } from "@/layout";
import { useLoading } from "@/contexts/LoadingContext";
import { Logo } from "@/components/Header/Logo";
import { CardLoginIdent } from "@/components/Cards";
import { CardRequestNewPasswordIdent } from "@/components/Cards/CardRequestNewPasswordIndent";
import { CollapseLog } from "@/components/Form/collapseLog";

export default function Cadastro() {
  const { setActionIsLoading } = useLoading();
  setActionIsLoading(false);
  const isWideVersion = useBreakpointValue({
    base: false,
    xs: false,
    sm: false,
    md: false,
    lg: true,
    xl: true
  });

  return (
    <SEO
      title="Loja Oficial LingLong - Faça seu Cadastro"
      description="Loja Oficial LingLong | Cadastro | Compre Pneus Online e Receba Super Rápido.
      Promoções de pneus LingLong ✓ Menor Custo de Frete ✓ Compra Segura em até 12x."
      path="/cadastro"
    >
      <Layout pt="2rem">
        {/* {cartItems ? ( */}
        <ContentBox mt={!isWideVersion && "50px"} justifyContent={"center"}>
          <Box width={["90%", "100%"]}>
            <Flex w={"100%"} direction="column" alignItems={"center"}>
              <CollapseLog startCreate={true} />
            </Flex>
          </Box>
        </ContentBox>
        {/* // ) : null} */}
      </Layout>
    </SEO>
  );
}
